import { render, staticRenderFns } from "./ListaAgenti.vue?vue&type=template&id=d7352486&"
import script from "./ListaAgenti.vue?vue&type=script&lang=js&"
export * from "./ListaAgenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports